import { render, staticRenderFns } from "./PageTemplate.vue?vue&type=template&id=72dd65b7&scoped=true&"
import script from "./PageTemplate.vue?vue&type=script&lang=ts&"
export * from "./PageTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./PageTemplate.vue?vue&type=style&index=0&id=72dd65b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dd65b7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
installComponents(component, {VCol,VProgressLinear,VRow,VStepper,VStepperContent,VStepperItems})
